import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import buscarEnderecoPorCep from '../../actions/endereco/buscarEnderecoPorCep';
import {apenasNumero, renderFieldCep, renderFieldText, required} from '../../util/inputs';
import selecionarEndereco from '../../actions/endereco/selecionarEndereco';
import cadastrarEndereco from '../../actions/endereco/cadastrarEndereco';
import {showSuccessMsg} from '../../util/messagesUtil';

const selector = formValueSelector('formularioCadastroEnderecoPessoa');

export class ModalCadastroEnderecoPessoa extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  fecharModal () {
    $('#modalCadastrarEnderecoPessoa')
      .modal('hide');
    $('#modalCadastrarEnderecoPessoa')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    const parametros = {
      idPessoa: this.props.pessoa.id,
      logradouro: values.logradouro,
      numero: values.numero,
      complemento: values.complemento,
      bairro: values.bairro,
      cep: values.cep,
      estado: values.uf,
      cidade: values.localidade,

    };
    this.props.cadastrarEndereco(parametros).then(() => {
        showSuccessMsg('Endereço cadastrado com sucesso');
        this.fecharModal();
        this.props.buscarPessoa(this.props.pessoa.cpfCnpj)
    })
  }


  exibirPesquisarCep () {
    return (<div className="col-md-5">
      <div className='row'>
        <Field name="cep" type="text" component={renderFieldCep} label="CEP:"
               css="form-control"/>
        <button className='btn btn-laranja btn-sm ml-2 mt-auto' style={{ height: 35 }}
                onClick={() => this.props.buscarEnderecoPorCep(apenasNumero(this.props.cep))}
                disabled={apenasNumero(this.props.cep).length !== 8}>
          <i className="material-icons">&#xe8b6;</i>
        </button>
      </div>
    </div>)
  }

  componentDidUpdate (prevProps) {
    if (!this.props.cep || this.props.cep < prevProps.cep || this.props.cep !== prevProps.cep) {
      this.props.selecionarEndereco({});
    }
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarEnderecoPessoa' role='dialog'
           aria-labelledby='modalCadastrarEnderecoPessoa' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Cadastro de Endereço</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              {this.exibirPesquisarCep()}
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    <Field name="logradouro" validate={[required]} type="text" component={renderFieldText} label="Logradouro:"
                           css="form-control"/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    <Field name="complemento" type="text" component={renderFieldText} label="Complemento:"
                           css="form-control"/>
                  </div>
                  <div className="col-12 col-sm-9 col-md-3">
                    <Field name="numero" validate={[required]} type="text" component={renderFieldText} label="Número:"
                           css="form-control"/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name="bairro" validate={[required]} type="text" component={renderFieldText} label="Bairro:"
                           css="form-control"/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name="localidade" validate={[required]} type="text" component={renderFieldText} label="Localidade:"
                           css="form-control"/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-12 col-sm-4 col-md-4">
                    <Field name="uf" validate={[required]} type="text" component={renderFieldText} label="UF:"
                           css="form-control"/>
                  </div>
                </div>
                <div className="modal-footer mt-4">
                  <button id='cancelar' type="button" className="btn btn-outline-secondary"
                          data-dismiss="modal">Cancelar
                  </button>
                  <button type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps (state) {
  return {
    perfisSelecionados: state.perfisSelecionados,
    empresaSelecionada: state.empresaSelecionada,
    initialValues: {
      localidade: state.endereco.localidade,
      complemento: state.endereco.complemento,
      bairro: state.endereco.bairro,
      logradouro: state.endereco.logradouro,
      uf: state.endereco.uf,
      cep: state.endereco.cep
    },
    cep: selector(state, 'cep')
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    selecionarEndereco,
    buscarEnderecoPorCep,
    cadastrarEndereco
  }, dispatch)
);


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroEnderecoPessoa',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalCadastroEnderecoPessoa));
